import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var CheckboxGroupChangeModelLazy = /*#__PURE__*/function () {
  function CheckboxGroupChangeModelLazy(group, calcAllValues, calcGroupValues, calcGroupItems) {
    _classCallCheck(this, CheckboxGroupChangeModelLazy);

    _defineProperty(this, "group", void 0);

    _defineProperty(this, "calcAllValues", void 0);

    _defineProperty(this, "calcGroupValues", void 0);

    _defineProperty(this, "calcGroupItems", void 0);

    _defineProperty(this, "_allValues", void 0);

    _defineProperty(this, "_groupValues", void 0);

    _defineProperty(this, "_groupItems", void 0);

    this.group = group;
    this.calcAllValues = calcAllValues;
    this.calcGroupValues = calcGroupValues;
    this.calcGroupItems = calcGroupItems;
  }

  _createClass(CheckboxGroupChangeModelLazy, [{
    key: "allValues",
    get: function get() {
      var _this$_allValues;

      (_this$_allValues = this._allValues) !== null && _this$_allValues !== void 0 ? _this$_allValues : this._allValues = this.calcAllValues();
      return this._allValues;
    }
  }, {
    key: "groupValues",
    get: function get() {
      var _this$_groupValues;

      (_this$_groupValues = this._groupValues) !== null && _this$_groupValues !== void 0 ? _this$_groupValues : this._groupValues = this.calcGroupValues();
      return this._groupValues;
    }
  }, {
    key: "groupItems",
    get: function get() {
      var _this$_groupItems;

      (_this$_groupItems = this._groupItems) !== null && _this$_groupItems !== void 0 ? _this$_groupItems : this._groupItems = this.calcGroupItems();
      return this._groupItems;
    }
  }]);

  return CheckboxGroupChangeModelLazy;
}();